export default __webpack_public_path__ + "static/media/placeholder_business06-nl-web.f8055aa6.png";